###
NOTE FOR PRICE FIELD:
Price field is shown only main product and not variant, because putting it on variant would require to persist all
  current variants and creating new one via Product page would not auto-include it in promotions
Price field should be used with default price region and currently it's not possible to change it as
  there is no relation between price regions and campaigns.
@TODO: Assign campaign to price region and select retail_price based on that relation.

@author Justinas Jurciukonis (justinas.jurciukonis@visma.com)
@company Visma Lietuva
###

angular
	.module 'App.Directive'
	.directive 'selectableProduct', ->
		restrict: 'EA'
		templateUrl: '@directive/selectable-product/selectable-product.view.html'
		scope:
			product: '='
			withVariants: '@'
			showPriceField: '=?'
		controller: 'SelectableProductController'
		controllerAs: 'selectableProduct'
		bindToController: true

class SelectableProductController extends AbstractController
	@register angular.module 'App.Directive'

	initialize: ->
		@showPriceField ?= false

	isAnyVariantSelected: ->
		for variant in @product.product_variants
			if variant.selected == true
				return true
		return false

	toggleSelectedProduct: ->
		for variant in @product.product_variants
			variant.selected = @product.selected

	toggleSelectedProductVariant: ->
		@product.selected = @isAnyVariantSelected @product

	shortenProductId: (id, from = 0, to = 8) ->
		return id
			.substring(from, to)
			# Regex matches non-alphanumeric characters at the end of string
			.replace(/[^a-z\d]*$/gi,'')
